export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  CASES: '/cases',
  CASE_DETAIL: '/cases/:caseId',
  SEARCH: '/search',
  UPLOAD: '/upload',
  DRAFTS: '/drafts',
  UPLOAD_STATUS: '/upload-status',
  ACCESS_REQUEST: '/access-request',
  ACCESS_STATUS: '/access-status',
  NOTIFICATIONS: '/notifications',
  CONTENT_MGMT: '/content-management',
  ARCHIVE: '/archive',
  FAVORITES: '/favorites',
  LATEST_FILES: '/latest-files',
  AUDIT: '/audit',
  REPORTS: '/reports',
  STORAGE_SYNC: '/storage-sync',
  DOCUMENT_VIEWER: '/viewer',
  /** Encoded in QR — always forces logout + login before case view */
  CASE_QR_ENTRY: '/qr/scan/:caseId',
  /** Post-login mobile case view (not used in QR payload) */
  CASE_QR_VIEW: '/qr/cases/:caseId',
  ADMIN: '/admin',
  ADMIN_MASTERS: '/admin/masters',
  ADMIN_USERS: '/admin/users',
} as const;

